import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from "@angular/common/http";
import {Globals} from "../../global/globals";
import {Observable} from "rxjs";
import {TextTypeDto} from "../../dtos/text/text-type/text-type-dto";
import {SharedService} from "../common/shared.service";
import {FormOptionsLists} from "../../shared/FormOptionsLists";

@Injectable({
  providedIn: 'root'
})
export class TextTypeService {

  // filter options
  formOptionsLists = new FormOptionsLists();

  private textTypeBaseUri: string = this.globals.backendUri + '/text/types';

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  searchEntries(params: HttpParams): Observable<any> {
    return this.httpClient.get(this.textTypeBaseUri, {params});
  }

  getEntry(id: number): Observable<TextTypeDto> {
    return this.httpClient.get<TextTypeDto>(this.textTypeBaseUri + '/' + id);
  }

  createEntry(pattern: TextTypeDto): Observable<TextTypeDto> {
    return this.httpClient.post<TextTypeDto>(this.textTypeBaseUri, pattern);
  }

  updateEntry(id: number, pattern: TextTypeDto): Observable<TextTypeDto> {
    return this.httpClient.put<TextTypeDto>(this.textTypeBaseUri + '/' + id, pattern);
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.textTypeBaseUri + '/' + id);
  }

  exportAll(): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(this.textTypeBaseUri, {observe: 'response', responseType: 'blob'});
  }

  /* -------------------- Other -------------------- */

  getEntryAsArray(entry: TextTypeDto) {
    const tmpEntries = this.sharedService.filterNullOrEmpty(this.sharedService.extractReferences(entry));

    const keyMap = {
      modes: {label: 'Fertigkeit', map: this.formOptionsLists.modesToString},
      interactions: {label: 'Interaktion', map: this.formOptionsLists.interactionsToString},
      domains: {label: 'Bereich', map: this.formOptionsLists.domainsToString},
      media: {label: 'Medium', map: this.formOptionsLists.mediaToString},
      purposes: {label: 'Zweck', map: this.formOptionsLists.purposesToString},
      representations: {label: 'Darstellungsform', map: this.formOptionsLists.representationsToString},
    };

    return tmpEntries
      .filter(([key]) => key !== 'id' && key !== 'name')
      .map(([key, value]) => {
        if (keyMap[key]) {
          return [keyMap[key].label, value.map(v => keyMap[key].map.get(v))];
        }
        return [key, value];
      });
  }


}
